import { all, fork } from 'redux-saga/effects';
import { listSchedulesSaga } from './list-schedules';
import { createScheduleSaga } from './create-schedule';
import { deleteScheduleSaga } from './delete-schedule';
import { updateScheduleSaga } from './update-schedule';
export function* rootSaga() {
    yield all([fork(listSchedulesSaga), fork(createScheduleSaga), fork(deleteScheduleSaga), fork(updateScheduleSaga)]);
}
